"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mergeHead_1 = __importDefault(require("./mergeHead"));
exports.default = (function () {
    return {
        beforeCreate: function () {
            var _this = this;
            if (this.$options && typeof this.$options.jsonld === 'function') {
                var originalHead_1 = this.$options.head;
                this.$options.head = function () {
                    return mergeHead_1.default.call(_this, originalHead_1);
                };
            }
        },
    };
});
